import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuth: false,
    token: localStorage.getItem("token"),
    user: null,
    id_user: localStorage.getItem("id_user"),
    password: null
  },
  mutations: {
    initialiseStore(state) {
      console.log("initial");
      if (localStorage.getItem("token")) {
        state.token = localStorage.getItem("token");
      }
    },
    setToken(state, token) {
      state.token = token;
      state.isAuth = true;
      window.localStorage.setItem("token", token);
    },
    setUserId(state, id_user) {
      state.id_user = id_user;
      window.localStorage.setItem("id_user", id_user);
    },
    setUserPass(state, credentials) {
      console.log("aaaaaaa");
      state.user = credentials.user;
      state.password = credentials.password;
      state.isAuth = true;
    },
    setSession(state, session) {
      state.session = session;
      state.isAuth = true;
      window.localStorage.setItem("session", session);
    },
    logout(state) {
      state.token = "";
      state.isAuth = false;
      window.localStorage.removeItem("token");
    }
  },
  actions: {},
  modules: {}
});
